import sdl from '@jds/react-generated-sdl/JDSBadgeV2Information';
import type { JDSBadgeV2InformationProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSBadgeV2InformationProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'label-icon',
    size = 'xtra-large',
    color = 'default',
    appearance = 'bold',
    border = false,
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, size, color, appearance, border, ariaLabel, ...rest },
    'JDSBadgeV2Information',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const BadgeV2Information = withLogic(
  Component
) as React.FC<JDSBadgeV2InformationProps> & { slotName?: string };

BadgeV2Information.displayName = 'BadgeV2Information';
BadgeV2Information.slotName = 'jds_badge_v_2_information';

export { BadgeV2Information, type JDSBadgeV2InformationProps };
